module.exports = __webpack_public_path__ + "static/img/zhineng.0f187a87.png";